// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span[data-v-285d12a8]{cursor:help}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/TableCellSelection.vue"],"names":[],"mappings":"AAEA,sBACC,WAAA","sourcesContent":["\n\nspan {\n\tcursor: help;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
